import { render, staticRenderFns } from "./SyllabusBuilder.vue?vue&type=template&id=883f08bc&scoped=true"
import script from "./SyllabusBuilder.vue?vue&type=script&lang=js"
export * from "./SyllabusBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883f08bc",
  null
  
)

export default component.exports